import { render, staticRenderFns } from "./ShowQueries.vue?vue&type=template&id=0dea5ed2&"
import script from "./ShowQueries.vue?vue&type=script&lang=js&"
export * from "./ShowQueries.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports